/**
 * Yap's settings dispatcher (settings-window plan).
 *
 * EVERY settings entry point — the suite bar's Settings button, the
 * 'openSettings' command (Ctrl+,) and the OPTIONS command — calls this one
 * helper: the in-app dialog opens by default, and the shared two-column
 * settings window raises when the user opted in (the panel's toggle).
 */
import { openAppSettings, settingsWindowUrl } from '@suite/settings';

export function openYapSettings(tab?: string): void {
    openAppSettings({
        request: { app: 'yap', url: settingsWindowUrl(tab) },
        openInApp: () =>
            window.dispatchEvent(
                new CustomEvent('yap:open-settings', { detail: { tab } }),
            ),
    });
}
